module.exports = __webpack_public_path__ + "static/img/banner.4043dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toolsData/banner.png
// module id = i+sU
// module chunks = 1